import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import sitesService from "@/services/site";
import useEncryption from "@/utils/helpers/encryption";

export const useSitesStore = defineStore("sites", () => {
  const toast = useToast();
  const { encryptionPassword } = useEncryption();
  const loading = ref(false);

  async function fetchSitesGrid(companyId) {
    loading.value = true;
    try {
      const res = await sitesService.getSitesGrid(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchSites(companyId) {
    loading.value = true;
    try {
      const res = await sitesService.getSites(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addSite(payload) {
    loading.value = true;
    try {
      const res = await sitesService.addSite(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editSite(payload) {
    loading.value = true;
    try {
      const res = await sitesService.editSite(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteSite(payload) {
    loading.value = true;
    try {
      const res = await sitesService.deleteSite(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function setSitePassword(payload) {
    loading.value = true;
    payload.password = await encryptionPassword(payload.password);
    try {
      const res = await sitesService.setSitePassord(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchSitesBySearch(payload) {
    loading.value = true;
    try {
      const res = await sitesService.getSitesBySearch(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchSitesGrid,
    fetchSites,
    fetchSitesBySearch,
    addSite,
    editSite,
    deleteSite,
    setSitePassword,
  };
});
